import React from 'react';
import AboutBanner from '../AboutBanner/AboutBanner';
import Team from './Team/Team';

const About = () => {
    return (
        <div>
            <AboutBanner></AboutBanner>
            <Team></Team>
        </div>
    );
};

export default About;